import React from 'react';
import { CheckCircle2, Clock, Shield, TrendingUp, Users, Award } from 'lucide-react';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Award,
      title: 'Professional Expertise',
      description: 'Qualified Chartered Accountant with deep knowledge and years of experience in financial services and compliance.'
    },
    {
      icon: Shield,
      title: 'Trusted & Reliable',
      description: 'Committed to maintaining the highest standards of integrity, confidentiality, and professional ethics.'
    },
    {
      icon: Users,
      title: 'Personalized Service',
      description: 'Dedicated attention to each client with customized solutions tailored to your specific needs and goals.'
    },
    {
      icon: TrendingUp,
      title: 'Result-Oriented',
      description: 'Focus on delivering tangible results that drive your financial success and business growth.'
    },
    {
      icon: Clock,
      title: 'Timely Delivery',
      description: 'Ensuring all compliance deadlines are met and services are delivered within agreed timelines.'
    },
    {
      icon: CheckCircle2,
      title: 'Comprehensive Support',
      description: 'One-stop solution for all your taxation, audit, compliance, and business advisory requirements.'
    }
  ];

  const stats = [
    { number: '500+', label: 'Happy Clients' },
    { number: '6+', label: 'Years Experience' },
    { number: '7000+', label: 'Tax Returns Filed' },
    { number: '98%', label: 'Client Satisfaction' }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">Why Choose Us</span>
          <h2 className="text-4xl font-bold text-slate-900 mt-3 mb-4">
            Your Success is Our Priority
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Experience the difference of working with a dedicated professional who truly cares about your financial well-being.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {reasons.map((reason, index) => {
            const IconComponent = reason.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-slate-50 hover:bg-teal-600 transition-all duration-300 hover:shadow-xl"
              >
                <div className="bg-teal-100 w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:bg-white transition-colors">
                  <IconComponent className="w-7 h-7 text-teal-700 transition-colors" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-white transition-colors">
                  {reason.title}
                </h3>
                <p className="text-slate-600 leading-relaxed group-hover:text-teal-50 transition-colors">
                  {reason.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="bg-gradient-to-br from-teal-600 to-slate-800 rounded-3xl p-12 shadow-2xl">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <p className="text-5xl font-bold text-white mb-2">{stat.number}</p>
                <p className="text-teal-100 text-lg">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
